import React from 'react';
import { parseMarkdown } from '../../helpers/parse-markdown';

const CompanyFAQItem = ({ title, content, id }) => {
  return (
    <div id={id} className="text-content" key={id}>
      <h3>{title}</h3>
      {content.map((item, index) => {
        if (item.type === "paragraph")
          return <p className="text-gray-900" key={index} dangerouslySetInnerHTML={{ __html: parseMarkdown(item.content) }} />

        if (item.type === "list") {
          const ListTag = item.ordered ? 'ol' : 'ul';
          return (
            <ListTag key={index} className="text-gray-900">
              {item.content.map((listItem, lIndex) => (
                <li key={lIndex} dangerouslySetInnerHTML={{ __html: parseMarkdown(listItem) }} />
              ))}
            </ListTag>
          );
        }

        if (item.type === 'quote')
          return <blockquote
            key={index}
            className="blockquote blockquote-primary bg-gray-100 p-5"
            dangerouslySetInnerHTML={{ __html: parseMarkdown(item.content) }}
          />

        if (item.type === "table") {
          return (
            <div key={index} className="table-responsive mb-4 text-gray-900">
              <table className="table table-bordered table-hover mb-0">
                {item.headers && item.headers.length > 0 && (
                  <thead>
                    <tr>
                      {item.headers.map((header, hIndex) => (
                        <th key={hIndex} className="text-gray-900" dangerouslySetInnerHTML={{ __html: parseMarkdown(header) }} />
                      ))}
                    </tr>
                  </thead>
                )}
                {item.rows && item.rows.length > 0 && (
                  <tbody>
                    {item.rows.map((row, rIndex) => (
                      <tr key={rIndex}>
                        {row.map((cell, cIndex) => (
                          <td key={cIndex} className="text-gray-900" dangerouslySetInnerHTML={{ __html: parseMarkdown(cell) }} />
                        ))}
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          );
        }
      })}
    </div>
  );
}

export default CompanyFAQItem;
